import React from 'react';
import { CloudArrowUpIcon } from '@heroicons/react/24/outline';
import { clsx } from 'clsx';

export default function SaveButton({ onClick, disabled }) {
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={clsx(
        'flex items-center gap-2 px-4 py-2 rounded-md text-white transition-colors',
        disabled ? 'bg-gray-400 cursor-not-allowed' : 'bg-indigo-600 hover:bg-indigo-700'
      )}
    >
      <CloudArrowUpIcon className="h-5 w-5" />
      <span>{disabled ? 'Saved' : 'Save changes'}</span>
    </button>
  );
}